var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEqual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9596 9.008C14.8236 9.4 14.6116 9.708 14.3236 9.932C14.0356 10.156 13.7076 10.268 13.3396 10.268C13.0996 10.268 12.8636 10.224 12.6316 10.136C12.3996 10.048 12.1196 9.92 11.7916 9.752C11.5196 9.616 11.3156 9.52 11.1796 9.464C11.0436 9.408 10.9076 9.38 10.7716 9.38C10.3396 9.38 10.0356 9.636 9.85964 10.148L9.05564 9.632C9.19164 9.24 9.40364 8.932 9.69164 8.708C9.97964 8.484 10.3076 8.372 10.6756 8.372C10.9236 8.372 11.1596 8.416 11.3836 8.504C11.6156 8.592 11.8916 8.716 12.2116 8.876C12.4756 9.004 12.6796 9.1 12.8236 9.164C12.9676 9.22 13.1076 9.248 13.2436 9.248C13.4676 9.248 13.6516 9.188 13.7956 9.068C13.9396 8.94 14.0596 8.752 14.1556 8.504L14.9596 9.008ZM14.9596 11.432C14.8236 11.824 14.6116 12.132 14.3236 12.356C14.0356 12.58 13.7076 12.692 13.3396 12.692C13.0996 12.692 12.8636 12.648 12.6316 12.56C12.3996 12.472 12.1196 12.344 11.7916 12.176C11.5196 12.04 11.3156 11.944 11.1796 11.888C11.0436 11.832 10.9076 11.804 10.7716 11.804C10.3396 11.804 10.0356 12.06 9.85964 12.572L9.05564 12.056C9.19164 11.664 9.40364 11.356 9.69164 11.132C9.97964 10.908 10.3076 10.796 10.6756 10.796C10.9236 10.796 11.1596 10.84 11.3836 10.928C11.6156 11.016 11.8916 11.14 12.2116 11.3C12.4756 11.428 12.6796 11.524 12.8236 11.588C12.9676 11.644 13.1076 11.672 13.2436 11.672C13.4676 11.672 13.6516 11.612 13.7956 11.492C13.9396 11.364 14.0596 11.176 14.1556 10.928L14.9596 11.432Z",
    fill: "#1D6295"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 19,
    rx: 2.5,
    stroke: "#1D6295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqual);
export default __webpack_public_path__ + "static/media/equal.d0fbc986c63a4fca4d427d6bca092af8.svg";
export { ForwardRef as ReactComponent };